/**
 * Znaki dostawcow logowania spolecznosciowego.
 * Osobny plik, zeby nie zasmiecac widoku logowania sciezkami SVG.
 */

export function GoogleIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={className}>
      <path
        fill="#4285F4"
        d="M23.52 12.27c0-.85-.08-1.67-.22-2.45H12v4.63h6.46a5.52 5.52 0 0 1-2.4 3.62v3h3.88c2.27-2.09 3.58-5.17 3.58-8.8Z"
      />
      <path
        fill="#34A853"
        d="M12 24c3.24 0 5.96-1.08 7.94-2.91l-3.88-3.01c-1.08.72-2.45 1.15-4.06 1.15-3.13 0-5.78-2.11-6.73-4.95H1.26v3.09A12 12 0 0 0 12 24Z"
      />
      <path
        fill="#FBBC05"
        d="M5.27 14.28a7.2 7.2 0 0 1 0-4.56V6.63H1.26a12 12 0 0 0 0 10.74l4.01-3.09Z"
      />
      <path
        fill="#EA4335"
        d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.44-3.44C17.95 1.19 15.24 0 12 0A12 12 0 0 0 1.26 6.63l4.01 3.09C6.22 6.88 8.87 4.75 12 4.75Z"
      />
    </svg>
  );
}

export function AppleIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={className} fill="currentColor">
      <path d="M17.05 12.7c-.03-2.6 2.12-3.85 2.22-3.91-1.21-1.77-3.09-2.02-3.76-2.04-1.6-.16-3.12.94-3.93.94-.81 0-2.06-.92-3.39-.9-1.74.03-3.35 1.01-4.25 2.57-1.81 3.14-.46 7.79 1.3 10.34.86 1.25 1.89 2.65 3.24 2.6 1.3-.05 1.79-.84 3.36-.84s2.01.84 3.38.81c1.4-.02 2.28-1.27 3.13-2.53.99-1.45 1.4-2.86 1.42-2.93-.03-.01-2.72-1.04-2.75-4.13ZM14.47 4.7c.71-.87 1.19-2.07 1.06-3.28-1.02.04-2.26.68-3 1.55-.66.76-1.24 1.99-1.09 3.16 1.14.09 2.31-.58 3.03-1.43Z" />
    </svg>
  );
}

/**
 * Uproszczony znak sportu rakietowego — pilka z szwem.
 * Uzywany w pasku dyscyplin na ekranie logowania.
 */
export function SportBallIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={className}>
      <circle cx="12" cy="12" r="10" fill="var(--color-brand)" />
      <path
        d="M4.5 5.5c3.2 2.1 4.6 4.6 4.4 8.2-.13 2.4-1.3 4.3-2.9 5.6M19.5 5.5c-3.2 2.1-4.6 4.6-4.4 8.2.13 2.4 1.3 4.3 2.9 5.6"
        fill="none"
        stroke="var(--color-fg-on-brand)"
        strokeOpacity="0.55"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  );
}
